import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import styles from './NewsCard.module.scss';
import classNames from 'classnames';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
export interface NewsCardProps {
	className?: string;
	date: string;
	image?: { url: string; altText: string };
	title: string;
	teaser: string;
	link: { url: string; name: string };
}

export const UI_NewsCard = ({ className, date, image, title, teaser, link }: NewsCardProps) => {
	return (
		<a
			className={classNames(styles.NewsCard, { [styles.NewsCard___withoutImage]: image?.url === undefined }, className)}
			href={link.url}
			title={link.name}
		>
			<p className={styles.NewsCard_date}>{date}</p>
			{image?.url && (
				<div className={styles.NewsCard_imageWrapper}>
					<UI_Picture className={styles.NewsCard_image} url={image.url} altText={image.altText} />
				</div>
			)}
			<p className={styles.NewsCard_title}>{title}</p>
			<UI_RichText className={styles.NewsCard_teaser} content={teaser} />
		</a>
	);
};
